import React, { useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import {indexWrapCss, widthCss} from "./css/MyPage.style"
import {ReactComponent as MypageBack} from 'src/assets/mypage_back.svg';
import MyPage from "./NewMyPage";
/*import MyPage from "./MyPage";*/

interface Props {
    profileList: any;
    bookData: any;
    postcardData: any,
    authorData: any,
    mypageBookData: any,
    mypagePostCardData: any,
    bookPage: number;
    postcardPage: number;
    handlePageChange: (type: 'book' | 'postcard' | 'author' | 'mypageBook' | 'mypagePostcard', newPage: number) => void;
}

const MypageLayout = ({ profileList, bookData, postcardData, authorData, mypageBookData, mypagePostCardData,bookPage, postcardPage,handlePageChange }: Props) => {
    const [search, setSearch] = useState("");

    const pageProps = {
        profileList,
        bookData,
        postcardData,
        authorData,
        mypageBookData,
        mypagePostCardData,
        bookPage,
        postcardPage,
        handlePageChange
    };

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    return (
        <MyPage {...pageProps}/>
    );
};

export default MypageLayout;
